// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFeeTransferCreateDto
 */
export interface IFeeTransferCreateDto {
    /**
     * 
     * @type {number}
     * @memberof IFeeTransferCreateDto
     */
    fee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeTransferCreateDto
     */
    fee_modification_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeTransferCreateDto
     */
    account_id_to: number;
}

/**
 * Check if a given object implements the IFeeTransferCreateDto interface.
 */
export function instanceOfIFeeTransferCreateDto(value: object): value is IFeeTransferCreateDto {
    if (!('account_id_to' in value) || value['account_id_to'] === undefined) return false;
    return true;
}

export function IFeeTransferCreateDtoFromJSON(json: any): IFeeTransferCreateDto {
    return IFeeTransferCreateDtoFromJSONTyped(json, false);
}

export function IFeeTransferCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFeeTransferCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fee_id': json['fee_id'] == null ? undefined : json['fee_id'],
        'fee_modification_id': json['fee_modification_id'] == null ? undefined : json['fee_modification_id'],
        'account_id_to': json['account_id_to'],
    };
}

export function IFeeTransferCreateDtoToJSON(json: any): IFeeTransferCreateDto {
    return IFeeTransferCreateDtoToJSONTyped(json, false);
}

export function IFeeTransferCreateDtoToJSONTyped(value?: IFeeTransferCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fee_id': value['fee_id'],
        'fee_modification_id': value['fee_modification_id'],
        'account_id_to': value['account_id_to'],
    };
}

